import React from 'react';
import PropTypes from 'prop-types';

import Icon, { GLYPHS } from '../../../../common/icon';
import SimpleHeader from '../../../../main/headers/simpleHeader';
import { t } from '../../../../../modules/infra/i18n';
import {
  Names,
  Header,
  Loyalty,
  CheckboxRow,
  ConfirmationModal,
  UpcomingAppointments,
  Notes,
} from './components';

const hasLoyalty = (duplicates, survivingCustomer) => (
  ![...duplicates, survivingCustomer].every(d => (!d.loyaltyReward && !d.loyaltyRewardCounter))
);

const MergeDuplicates = (props) => {
  const duplicateCellClass = `c-table-card__cell u-${6 / props.duplicates.length}/12 u-break-word`;
  const scheme = Object.keys(props.inputs);
  return (
    <div>
      <ConfirmationModal display-if={props.modalIsOn} close={props.modalOff} confirm={props.submit} />
      <SimpleHeader heading={t('customers:duplicates.heading')} />
      <div className="c-wrapper o-page-height">
        <form onSubmit={props.showModal}>
          <fieldset disabled={props.submitting}>
            <div className="c-table-card c-table-new c-no-hover">
              <Header duplicates={props.duplicates} duplicateCellClass={duplicateCellClass} />
              <Names
                duplicates={props.duplicates}
                selectAll={props.selectAll}
                duplicateCellClass={duplicateCellClass}
                isMobileSurvivingCustomer={props.isMobileSurvivingCustomer}
              />
              {
                scheme.map(key => (
                  <CheckboxRow
                    key={key}
                    duplicates={props.duplicates}
                    descriptor={props.inputs[key]}
                    cellClassName={duplicateCellClass}
                    onCheckboxChange={props.onCheckboxChange}
                    survivingCustomer={props.survivingCustomer}
                    disabled={props.isMobileSurvivingCustomer}
                    selectedIndices={props.selectedIndices}
                  />
                ))
              }
              <Loyalty
                display-if={hasLoyalty(props.duplicates, props.survivingCustomer)}
                duplicates={props.duplicates}
                survivingCustomer={props.survivingCustomer}
                duplicateCellClass={duplicateCellClass}
              />
              <UpcomingAppointments
                display-if={props.survivingCustomer.appointments.length}
                survivingCustomer={props.survivingCustomer}
                duplicates={props.duplicates}
                cellClassName={duplicateCellClass}
              />
              <Notes
                display-if={props.survivingCustomer.notes.length}
                survivingCustomer={props.survivingCustomer}
                duplicates={props.duplicates}
                cellClassName={duplicateCellClass}
              />
            </div>

            <div className="u-text-right u-mt">
              <button className="c-btn c-btn--medium">
                <span className="u-align-middle">{t('customers:duplicates.merge_records_button')}</span>
                <Icon glyph={GLYPHS.clone} size="micro" className="u-ml- u-align-middle" />
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  );
};

MergeDuplicates.propTypes = {
  submit: PropTypes.func.isRequired,
  modalIsOn: PropTypes.bool.isRequired,
  showModal: PropTypes.func.isRequired,
  modalOff: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  selectAll: PropTypes.func.isRequired,
  inputs: PropTypes.object.isRequired,
  duplicates: PropTypes.array.isRequired,
  survivingCustomer: PropTypes.object.isRequired,
  isMobileSurvivingCustomer: PropTypes.bool.isRequired,
  selectedIndices: PropTypes.object.isRequired,
};


export default MergeDuplicates;
